import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'professional') {
    return;
  }

  const $hasExercisedFinancialExperience = $('#hasExercisedFinancialExperience input[type=radio]', $form);
  const $hasFinancialExperience          = $('#hasFinancialExperience', $form)

  $hasExercisedFinancialExperience.each((_, inputElement) => {
    if(inputElement.checked && inputElement.value === 'true') {
      $hasFinancialExperience.removeClass('d-none');
    }
  });

  $hasExercisedFinancialExperience.on('click', (inputElement) => {
    if(inputElement.target.value === 'true') {
      $hasFinancialExperience.removeClass('d-none');
    } else {
      clearInputField(document.getElementById('users_profile_natural_has_exercised_financial_profession_details'));
      clearInputField(document.getElementById('users_profile_natural_has_exercised_financial_profession_duration'));
      $hasFinancialExperience.addClass('d-none');
    }
  });
})
